import { AppState } from 'src';
import { Dispatch, connect } from 'react-redux';
import { TradeZipsComponent, TradeZipsComponentProperties } from './trade-zips-component';
import { TradeViewModel, VendorViewModel, ExcludedZipViewModel } from '@models/Vendor';
import {
  getZipCountyOptions,
  deleteIncludedZips,
  saveIncludedZips,
  getVendorDetails,
  getExcludedZips,
  deleteExcludedZips,
  saveExcludedZips,
  getExclusionZipCountyOptions
} from 'src/vendor/vendor.actions';

interface ParentProps {
  readonly keyVal: string;
  readonly vendorVM: VendorViewModel;
  readonly currentTrade?: TradeViewModel;
  readonly isExclusion?: boolean;
  readonly readonly?: boolean;
  readonly isTab?: boolean;
}

function mapStateToProps(state: AppState, ownProps: ParentProps): Partial<TradeZipsComponentProperties> {
  return {
    keyVal: ownProps.keyVal,
    readonly: ownProps.readonly,
    address: state.vendor.vendorVM.address,
    id: state.vendor.vendorVM.id,
    coveredZips: state.vendor.vendorVM.coveredZips,
    currentTrade: ownProps.currentTrade,
    isExclusion: ownProps.isExclusion,
    // Different instances in the store for exclusion and inclusion components
    zipCountyOptions: ownProps.isExclusion
      ? state.vendor.exclusionZipCountyOptions && state.vendor.exclusionZipCountyOptions
      : state.vendor.zipCountyOptions && state.vendor.zipCountyOptions,
    excludedZips: state.vendor.excludedZips ? state.vendor.excludedZips : [],
    zipsSaving: state.vendor.zipsSaving,
    // Different instances in the store for exclusion and inclusion components
    loadingVendor: ownProps.isExclusion ? state.vendor.loadingZipsExclusions : state.vendor.loadingZips
  };
}

function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: ParentProps
): Partial<TradeZipsComponentProperties> {
  return {
    getVendorDetails: (id: number) => {
      return dispatch(getVendorDetails(id));
    },
    getZipExclusions: (id: number, tradeId: number) => {
      return dispatch(getExcludedZips(id, tradeId));
    },
    getZipCountyOptions: (stateAbbr: string) => {
      return ownProps.isExclusion
        ? dispatch(getExclusionZipCountyOptions(stateAbbr))
        : dispatch(getZipCountyOptions(stateAbbr));
    },
    saveChangesIncluded: (vendorId: number, includedZips: string[], toBeDeletedZips: string[], callback?: Function) => {
      return dispatch(deleteIncludedZips(vendorId, toBeDeletedZips)).then(() => {
        dispatch(saveIncludedZips(vendorId, includedZips)).then(() => {
          if (callback) {
            callback();
          }
        });
      });
    },
    saveChangesExcluded: (
      tradeId: number,
      vendorId: number,
      excludedZips: ExcludedZipViewModel[],
      toBeDeletedZips: ExcludedZipViewModel[],
      callback?: Function
    ) => {
      return dispatch(deleteExcludedZips(tradeId, vendorId, toBeDeletedZips)).then(() => {
        dispatch(saveExcludedZips(tradeId, vendorId, excludedZips)).then(() => {
          if (callback) {
            callback();
          }
        });
      });
    }
  };
}

export const TradeZipsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TradeZipsComponent);



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-trade-maintenance/trade-zips/_components/trade-zips.container.ts